import { passportClearFormatting } from '.';

function passportFormat(input: string | undefined | null): string {
  const cleared = passportClearFormatting(input);

  let result = '';

  for (let i = 0; i < cleared.length; i++) {
    if (i === 4) {
      result += ' ';
    }

    result += cleared[i];
  }

  return result;
}

export default passportFormat;
